import { Button } from '../ui/Button';
import { SOCIAL_PROVIDER_NAMES } from '../../services/authProviders';
import { useAuthStore } from '../../store/authStore';

/**
 * Shown after a provider sign-in hits an email that already has an account.
 * Whichever way the player signs in next with that email, the waiting
 * provider is linked onto the account (see `linkPendingCredential`).
 */
export default function LinkAccountNotice() {
    const { pendingLink, cancelPendingLink } = useAuthStore();
    if (!pendingLink) return null;

    return (
        <div
            data-testid="link-account-notice"
            role="status"
            className="flex flex-col gap-2 rounded-tile border border-status-info/40 bg-status-info/15 p-3 text-body text-content-primary"
        >
            <p>
                <span className="font-semibold">{pendingLink.email}</span> already has a Kaeliux account. Sign in
                with the method you used before and we&apos;ll connect {SOCIAL_PROVIDER_NAMES[pendingLink.provider]} to
                it.
            </p>
            <Button type="button" variant="ghost" size="sm" className="self-start" onClick={cancelPendingLink}>
                Cancel
            </Button>
        </div>
    );
}
